import { Component, OnInit } from '@angular/core';
import { StoryModel } from '../../../../api/amplify/model/amplify-reponse.model';
import { UnifiedStoryRequestModel } from '../../../../api/story/model/story-request.model';
import { UnifiedStoryResponseModel } from '../../../../api/story/model/story-response.model';
import { StorySearch } from '../../../../api/story/model/story-search.model';
import { StoryApi } from '../../../../api/story/story-api';
import { StatusEnum } from '../../enums/status.enum';
import { AmplifyTypesEnum } from '../../../../api/amplify/enums/amplify-types.enum';
import { AmplifyDialogComponentTextModel } from '../../../../Common/Dialogs/models/amplify-dialog-component-text.model';
import { AmplifyApi } from '../../../../api/amplify/amplify-api';
import { MessageService, TreeNode } from 'primeng/api';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LazyLoadEvent } from 'primeng/api';
import { StorySearchParams } from '../../../../api/story/model/story-search-Query-Params.model';
import { Router, ActivatedRoute } from '@angular/router';
import { RouteModel } from '../../models/route-data.model';

import { StoriesConstants} from './stories-constants';
import { Observable, mergeMap, of } from 'rxjs';
import { StoryInterface } from '../story/story.interface';
import { SubjectApi } from '../../../../api/subject/subject-api';
import { NewsroomSideBarModel } from '../../../Shared/models/newsroom-side-bar.model';
import { NewsroomSideBarItemModel } from '../../../Shared/models/newsroom-side-bar-item.model';
import { NotifyToStoryService } from '../../services/notify-to-story.service';
import { StorySubject } from '../../../../api/story/model/story-subject.model';
import { ArticleViewModel } from '../../../../api/amplify/model/amplify-article-model';
import { AmplifyStoryResultModel } from '../../../../api/amplify/model/amplify-unified.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import * as _ from 'underscore';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../../Common/Dialogs/models/confirm-dialog.model';
import { TextInputDialogModel } from '../../../../Common/Dialogs/models/text-input-dialog.model';
import { TextInputDialogComponent } from '../../../../Common/Dialogs/components/TextInputDialog/text-input-dialog.component';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { AbstractHypeService } from '../../../../Common/Layout/services/abstract-hype.service';
import { Status } from '../../../../api/story/model/status.model';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { NewsroomLeftSidebarService } from '../../services/newsroom-left-sidebar.service';
import { Mode } from '../../../../Common/Layout/enums/mode.enum';
import { DiscoverRoutingService } from '../../../../Discover/DiscoverRouter/services/discover-routing.service';
import { AmplifyRoutingService } from '../../../../Amplify/Core/services/amplify-routing.service';
@Component({
    selector: 'agpr-stories',
    templateUrl: './stories.component.html',
    styleUrls: ['./stories.component.scss'],
    providers: [
        StoryApi,
        StorySearch,
        AmplifyApi,
        UnifiedStoryRequestModel,
        StorySearchParams,
        SubjectApi,
        {
            provide: AbstractHypeService,
            useExisting: StoriesComponent
        },
        {
            provide: FilterService,
            useExisting: NewsroomLeftSidebarService
        }
    ],
    standalone: false
})

export class StoriesComponent extends AbstractHypeService implements OnInit, StoryInterface {
    public stories: Array<StoryModel>;
    public showStoryPreview: boolean = false;
    public routedComponent: any;
    public storyId: number = 0;
    // 	Number of total stories, defaults to length of value when not defined.
    public totalRecords: number;
    public scrollerDataLoaded: boolean = false;
    public showImageInChildComponent: boolean = false;

    public statusEnum = StatusEnum;

    public storyList: StoryModel[];
    public display: boolean = false;
    public selectedStory: StoryModel;
    public type: AmplifyTypesEnum;
    public keyword: string;
    public storyTypes: any[];
    public localization = new AmplifyDialogComponentTextModel();
    public minResult: number = 5;
    public maxResult: number = 25;
    public storyDetail: any;
    public isAmplify: boolean = false;
    public storyType: AmplifyTypesEnum = AmplifyTypesEnum.Newsroom;
    public timeLimit: string = StoriesConstants.timeLimit;
    public storyResponseModel: UnifiedStoryResponseModel[] = [];
    public storyRequestModel: UnifiedStoryRequestModel;
    public storyLoading: boolean = true;
    public totalStories: number = 0;
    public start: number = 0;
    public displayRows: number = 100;
    public availableOptions: string[] = [];
    public selectedStories: string[] = [];
    public multipleSearchStories: string[] = [];
    public lazyLoadEvent: LazyLoadEvent = null;
    public isLoading: boolean =  false;
    public storyLabel: string = StoriesConstants.storyLabel;
    public statusLabel: string = StoriesConstants.statusLabel;
    public sideBarNoItemsText: string = StoriesConstants.sideBarNoItemsText;
    public sideBarItemLabel: string = StoriesConstants.sideBarItemLabel;
    public sidebarAmplifyLabel: string = StoriesConstants.sidebarAmplifyLabel;
    public sidebarSections: DropdownOptionModel[] = [
        new DropdownOptionModel(
            StoriesConstants.sidebarSectionNewsroom,
            Mode.newsroom
        )
    ];
    public sidebarSelectedSectionValue: DropdownOptionModel = this.sidebarSections[0];
    public showStories: boolean = false;
    public scrollHeight: number;
    public amplifyTotalRecords: number = 0;
    public sidebarModel: NewsroomSideBarModel = new NewsroomSideBarModel();
    public selectedItem: NewsroomSideBarItemModel = new NewsroomSideBarItemModel();


    constructor(
        private storyApi: StoryApi,
        private amplifyApi: AmplifyApi,
        public configService: ConfigService,
        private router: Router,
        private discoverRoutingService: DiscoverRoutingService,
        private amplifyRoutingService: AmplifyRoutingService,
        private activatedRoute: ActivatedRoute,
        private subjectApi: SubjectApi,
        public notifyToStoryService: NotifyToStoryService,
        private currentUserStateService: CurrentUserStateService,
        private messageService: MessageService,
        private coreDialogService: CoreDialogService,
        private newsroomLeftSidebarService: NewsroomLeftSidebarService,
    ) {
        super();
        this.scrollHeight = window.innerHeight - 208;
        this.newsroomLeftSidebarService.getListItems().subscribe(listItems => {
            if (!this.storyLoading) {
                this.sidebarModel.items = listItems;
            }
        });
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(() => {
            const child = this.activatedRoute.firstChild;
            if (child) {
                this.selectedItem.id = 0;
                child.data.subscribe(routeData => {
                    if (routeData.routeModel &&
                        routeData.routeModel.storyId > 0 &&
                        !routeData.routeModel.isAmplified) {
                        this.selectedItem.id = routeData.routeModel.storyId;
                        if (!routeData.routeModel.isFromParent) {
                            this.start = 0;
                            this.getStories();
                        }
                    } else {
                        child.params.subscribe(params => {
                            if (params['id']) {
                                this.selectedItem.id = +params['id'];
                            }
                        });
                    }
                });
                this.showStoryPreview = true;
            }
        });
        this.getStories();

        this.storyTypes = [
            { label: AmplifyTypesEnum.Recent, value: AmplifyTypesEnum.Recent },
            { label: AmplifyTypesEnum.Newsroom, value: AmplifyTypesEnum.Newsroom }
        ];
        this.setSidebarSections();

        this.hypeConfig = {
            icon: 'fa-kit-duotone fa-agpr-hype-newsroom',
            headingText: 'NEWSROOM',
            line1Text: 'Make it easier for your target audience and journalists to find your story by posting on our newsroom.',
            line2Text: 'Let\'s get started.',
            linkText: 'New Story'
        };
        this.hypeConfigProvider.next(this.hypeConfig);
    }

    /**
     * Set sidebarsections based on account permission
     */
    setSidebarSections(): void {
        this.currentUserStateService
            .getPermissions()
            .subscribe(permissions => {
                if (!permissions) {
                    return;
                }

                const sidebarSections: DropdownOptionModel[] = [
                    new DropdownOptionModel(StoriesConstants.sidebarSectionNewsroom, Mode.newsroom)
                ];

                const hasAccessWire: boolean = permissions.includes(userPermissionsEnum.newswireplus);
                this.configService.accesswireMode = hasAccessWire;
                if (hasAccessWire) {
                    sidebarSections.push(new DropdownOptionModel('Core.navigation.mediaRelations.newswire', Mode.wire));

                    if (permissions.includes(userPermissionsEnum.wireEditorial)) {
                        sidebarSections.push(new DropdownOptionModel('Amplify.leftSidebar.wire.review', Mode.editorial));
                    }
                }

                if (permissions.includes(userPermissionsEnum.advancedTargeting)) {
                    sidebarSections.unshift(
                        new DropdownOptionModel('Core.navigation.mediaRelations.savedSearches', Mode.searches),
                        new DropdownOptionModel('Core.navigation.mediaRelations.targetedLists', Mode.targetingLists),
                        new DropdownOptionModel('Core.navigation.mediaRelations.distributions', Mode.distributions),
                    );
                    sidebarSections.push(
                        new DropdownOptionModel('Core.navigation.mediaRelations.privateContacts', Mode.privateContacts)
                    );
                }

                this.sidebarSections = sidebarSections;
            });
    }

    onFilter(): void {
        this.getStories();
    }

    getStory(storyId: number): Observable<UnifiedStoryResponseModel> {
        return this.storyApi.getStoryAPI(storyId);
    }

    updateStory(storyId: number, story: UnifiedStoryRequestModel): Observable<UnifiedStoryResponseModel> {
        return this.storyApi.updateStoryAPI(storyId, story);
    }

    getImage(url: string): Observable<Blob> {
        return this.storyApi.getImage(url);
    }

    createStory(story: UnifiedStoryRequestModel): Observable<UnifiedStoryResponseModel> {
        return this.storyApi.createStoryAPI(story);
    }

    getSubjectList(): Observable<StorySubject[]> {
        return this.subjectApi.getSubjectListAPI();
    }

    /**
    * Get article details from Newswire
    */
    getArticleDetailFromNewswire(
        storyId: number
    ): Observable<ArticleViewModel> {
        return this.amplifyApi.getNewswireArticleDetail(storyId);
    }

    getStories(status: boolean = true): void {
        const storySearchModel: StorySearch = new StorySearch;
        const searchParams: StorySearchParams = new StorySearchParams;

        storySearchModel.storyNames = [];
        searchParams.rows = this.displayRows;
        searchParams.start = 0;

        this.sidebarModel.items = [];
        this.storyLoading = true;
        if (status === true) {
            this.storyApi.getAllStories(
                <StorySearch>storySearchModel, searchParams
            ).subscribe({
                next: (data) => {
                    this.storyResponseModel = data.stories;
                    this.sidebarModel.totalItemCount = data.totalCount;
                    this.storyLoading = false;
                    this.totalStories = data.totalCount;
                    data.stories.forEach(storyItem => {
                        this.availableOptions.push(storyItem.id.toString());
                        const sideBarItem: NewsroomSideBarItemModel = new NewsroomSideBarItemModel();
                        sideBarItem.id = storyItem.id;
                        sideBarItem.name = storyItem.name;
                        sideBarItem.status = StoriesConstants.statusLabels[storyItem.statusId];
                        sideBarItem.options = [
                            {label: 'Lhp.actions.copy', icon: 'fa-kit-duotone fa-agpr-copy', command: (_data) => this.copyStory((_data as any).data) },
                            {label: 'Lhp.actions.delete', icon: 'fa-regular fa-duotone fa-trash-can', command: (_data) => this.deleteStory((_data as any).data) }
                        ];
                        sideBarItem.createdDate = new Date(storyItem.createdDate);
                        sideBarItem.createdByUserId = storyItem.createdUserId;
                        sideBarItem.modifiedDate = new Date(storyItem.modifiedDate);
                        sideBarItem.modifiedByUserId = storyItem.modifiedUserId;
                        this.sidebarModel.items.push(sideBarItem);
                    });
                    this.showStories = true;
                    this.newsroomLeftSidebarService.getFilterOptions( this.sidebarModel.items);
                    this.newsroomLeftSidebarService.setListItems(this.sidebarModel.items);
                    this.newsroomLeftSidebarService.applyFilters();
                },
                error: (error) => this.handleError(error)
            });
        }
    }

    public getFilterIds(filterOptions: TreeNode[]): number[] {
        const optionIds: number[] = [];
        if (filterOptions && filterOptions.length > 0 ) {
            filterOptions.forEach(option => {
                optionIds.push(option.data.id);
            });
        }
        return optionIds;
    }

    public loadPreviewPanel(storyId: number = 0, isAmplify: boolean = false, storyType: AmplifyTypesEnum = AmplifyTypesEnum.Newsroom): void {
        this.storyId = isAmplify ? 0 : storyId;
        this.isAmplify = isAmplify;
        this.storyType = storyType;
        this.showStoryPreview = true;
        this.notifyToStoryService.getStoryDirtyStatus.subscribe(status => {
            if (status === false) {
                this.notifyToStoryService.getDirtyStoryId.subscribe(dirtyStoryId => {
                    this.selectedItem.id = dirtyStoryId;
                });
            } else {
                this.selectedItem.id = this.storyId;
            }
        });
        const routeData: RouteModel = {
            isAmplified: isAmplify,
            storyType: storyType,
            isFromParent: true,
            storyId: storyId
        };
        this.router.navigate(
            ['story', this.storyId],
            {
                relativeTo: this.activatedRoute,
                queryParams: routeData
            }
        );
    }

    public getSavedStoryStatus(storyId: number): void {
        this.getStories();
        this.loadPreviewPanel(storyId);

    }

    public getAmplifyDialogStatus(event): void {
        if (event === true) {
            this.onCreateNewStory();
        }
    }

    public sidebarSectionChanged(value): void {
        switch (value) {
            case Mode.searches:
                this.discoverRoutingService.gotoTargetingHype();
                break;
            case Mode.targetingLists:
                this.discoverRoutingService.gotoListHype();
                break;
            case Mode.privateContacts:
                this.discoverRoutingService.gotoPrivateContacts();
                break;
            case Mode.distributions:
                this.discoverRoutingService.gotoDistributionHype();
                break;
            case Mode.discoverContacts:
                this.discoverRoutingService.gotoTargetingSearch();
                break;
            case Mode.wire:
                this.amplifyRoutingService.gotoWireHype();
                break;
            case Mode.editorial:
                this.amplifyRoutingService.gotoEditorialHype();
                break;
            case Mode.newsroom:
                this.router.navigate([StoriesConstants.newsroomRootPath]);
                break;
            default:
                break;
        }
    }

    public onCancel(): void {
        this.selectedStory = null;
        this.display = false;
    }

    public onClose(): void {
        this.selectedStory = null;
        this.display = false;
    }

    public onUseSelected(story: StoryModel): void {
        if (story.id > 0) {
            this.selectedStory = story;
            this.display = false;
            this.loadPreviewPanel(story.id, true, story.type);
        }
    }

    public onCreateNewStory(): void {
        this.selectedStory = new StoryModel();
        this.display = false;
        this.loadPreviewPanel();
    }

    public deleteStory(item: NewsroomSideBarItemModel): void {
        const storyId: number = item.id;
        const storyName: string = item.name;

        this.coreDialogService.open(
            ConfirmDialogComponent,
            {
                inputs: {
                    heading: StoriesConstants.confirmation,
                    messageHtml: StoriesConstants.confirmMessage + StoriesConstants.storyItemStart + storyName + StoriesConstants.storyItemEnd,
                    okLabel: StoriesConstants.acceptLabel,
                    cancelLabel: StoriesConstants.rejectLabel,
                    width: 350
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            this.storyApi.deleteStoryAPI(
                                <string>storyId.toString()
                            ).subscribe({
                                next: () => {
                                    const message = StoriesConstants.storyMessage + storyName + StoriesConstants.deleteMessage;
                                    this.showMessage(StoriesConstants.deleteStoryHeading, message, StoriesConstants.successSeverity);
                                    this.redirectionAfterStoryDelete(this.selectedItem, item.id);
                                },
                                error: (error) => {
                                    if (error.statusText === StoriesConstants.notfound) {
                                        this.showMessage(
                                            StoriesConstants.storyNotFoundHeading,
                                            StoriesConstants.storyNotExistMessage,
                                            StoriesConstants.errorSeverity
                                        );
                                    }
                                }
                            });
                        }
                    }
                }
            }
        );
    }

    public copyStory(item: NewsroomSideBarItemModel) {
        const inputConfig: TextInputDialogModel = {
            inputs: {
                width: 280,
                heading: 'Amplify.wire.copyStory',
                okLabel: 'Core.button.copy',
                description: 'Reports.copy.name',
                placeholder: 'Reports.copy.placeholder',
                formValidator: (name: string) => [],
                submit: (name: string) => {
                    this.storyApi.getStoryAPI(item.id).pipe(
                        mergeMap( _story => {
                            _story.name = name;
                            delete  _story.id;
                            _story.bodyContents?.forEach(content => {
                                delete content.id;
                            });
                            _story.links?.forEach(link => {
                                delete link.id;
                            });

                            _story.status = new Status();
                            _story.status.id = StatusEnum.DRAFT;
                            _story.statusId = StatusEnum.DRAFT;

                            return this.storyApi.createStoryAPI(_story);
                        })
                    ).subscribe({next: (x) =>  {
                        this.messageService.add({
                            severity : messageSeverityEnum.success,
                            summary: 'Amplify.wire.copyStory',
                            detail: 'Discover.confirmDialog.copy.success'
                        });
                        this.getStories();
                        this.loadPreviewPanel(x.id);
                    }, error: (x) => this.messageService.add({
                        severity : messageSeverityEnum.error,
                        summary: 'Amplify.wire.copyStory',
                        detail: 'Discover.confirmDialog.copy.error'})
                    });

                    return of(null);
                }
            }
        };
        this.coreDialogService.open(TextInputDialogComponent, inputConfig);
    }

    public fetchStories(event: LazyLoadEvent): void {
        this.storyLoading = true;
        const storySearchModel: StorySearch = new StorySearch;
        const searchParams: StorySearchParams = new StorySearchParams;

        storySearchModel.storyNames = [];

        if (event != null && event !== undefined) {
            if (event.sortField !== undefined) {
                switch (event.sortField) {
                    case StoriesConstants.name :
                    case StoriesConstants.author :
                    case StoriesConstants.modifiedDate :
                    case StoriesConstants.publishedDate :
                        searchParams.sortType = StoriesConstants.story;
                        break;

                    case StoriesConstants.status :
                        searchParams.sortType = StoriesConstants.status;
                        event.sortField = StoriesConstants.id;
                        break;

                    case StoriesConstants.subject :
                        searchParams.sortType = StoriesConstants.subject;
                        event.sortField = StoriesConstants.id;
                        break;
                }
                searchParams.sortBy = event.sortField;
                searchParams.sortOrder = event.sortOrder === 1 ? StoriesConstants.ascending : StoriesConstants.descending;
            }

            searchParams.rows = event.rows;
            searchParams.start = event.first;
        }

        if (this.multipleSearchStories != null && this.multipleSearchStories.length > 0) {
            storySearchModel.storyNames = this.multipleSearchStories;
        }

        this.availableOptions = [];

        if (this.totalStories !== undefined && this.totalStories === 0) {
            searchParams.start = 0;
            searchParams.rows = this.displayRows;
        }
        this.storyApi.getAllStories(
            <StorySearch>storySearchModel, searchParams
        ).subscribe({
            next: (data) => {
                this.storyResponseModel = data.stories;
                this.sidebarModel.totalItemCount = data.totalCount;
                this.storyLoading = false;
                this.totalStories = data.totalCount;
                data.stories.forEach(storyItem => {
                    this.availableOptions.push(storyItem.id.toString());
                    const sideBarItem: NewsroomSideBarItemModel = new NewsroomSideBarItemModel();
                    sideBarItem.id = storyItem.id;
                    sideBarItem.name = storyItem.name;
                    sideBarItem.status = StoriesConstants.statusLabels[storyItem.statusId];
                    sideBarItem.options = [
                        {label: 'Lhp.actions.copy', icon: 'fa-kit-duotone fa-agpr-copy', command: (_data) => this.copyStory((_data as any).data) },
                        {label: 'Lhp.actions.delete', icon: 'fa-regular fa-duotone fa-trash-can', command: (_data) => this.deleteStory((_data as any).data) }
                    ];
                    this.sidebarModel.items.push(sideBarItem);
                });
                this.showStories = true;
            },
            error: (error) => this.handleError(error)
        });
    }

    public setStoryDate(data: any): void {
        this.storyRequestModel.aboutUs = data[0].aboutUs;
        this.storyRequestModel.author = data[0].author;
        this.storyRequestModel.body =  data[0].body;
        this.storyRequestModel.company =  data[0].company;
        this.storyRequestModel.contacts = data[0].contacts;
        this.storyRequestModel.headline = data[0].headline;
        this.storyRequestModel.links = data[0].links;
        this.storyRequestModel.status = data[0].status;
        this.storyRequestModel.subjects = data[0].subjects;
    }

    public showMessage(headMessage: string, detailMessage: string, messageSeverity: string): void {
        this.messageService.add({severity: messageSeverity, summary: headMessage, detail: detailMessage});
    }

    getContentSnippet(content: string): string {
        if (content.length > StoriesConstants.maxNumberOfChars) {
            content = content.slice(0, StoriesConstants.maxNumberOfChars);
            content = content + StoriesConstants.ellipses;
        }
        return content;
    }

    public handleError(error): void {
        if (!error.status || error.status === 500) {
            this.showMessage(StoriesConstants.errorHeading, StoriesConstants.serverErrorMessage, 'error');
        } else {
            this.showMessage(StoriesConstants.errorHeading, error.statusText, 'error');
        }
    }

    /**
     * Sets amplify data to story list and sorts/slices stories in case of recent status
     */
    private setAmplifyData(
        amplifyData: AmplifyStoryResultModel,
        amplifyType: AmplifyTypesEnum,
        numberOfResults: number,
        isLoading: boolean = false,
    ): void {
        this.amplifyTotalRecords = amplifyData.totalCount;
        if (amplifyType === AmplifyTypesEnum.All) {
            amplifyData.stories.sort((a, b) => new Date(b.modifiedDate).getTime() - new Date(a.modifiedDate).getTime());
            this.storyList = amplifyData.stories.slice(0, numberOfResults);
        } else {
            this.storyList = amplifyData.stories;
        }
        this.isLoading = isLoading;
    }

    /**
     * Sets amplify data to story list and sorts/slices stories in case of recent status
     */
    private redirectionAfterStoryDelete(
        selectedItem: NewsroomSideBarItemModel,
        deleteStoryId: number
    ): void {
        if (selectedItem && (selectedItem.id === deleteStoryId)) {
            setTimeout(() => {
                this.router.navigate([StoriesConstants.newsroomRootPath]);
            }, 1000);
        } else {
            this.start = 0;
            this.getStories();
        }
    }

    buttonClicked(): void {
        this.getAmplifyDialogStatus(true);
    }

    secondaryButtonClicked(): void {}
}
